import { IContext } from '../types/IContext'
import {
  IAddBannerMessage,
  ISetBannerMessages,
  ISetPlanner,
  ISetUnsavedChanges,
  ISetUser,
} from './commonDispatch'
import { ISetIngredients } from './ingredientDispatch'

export enum ActionType {
  // Common
  setUnsavedChanges,
  setBannerMessages,
  addBannerMessage,
  setPlanner,
  setUser,
  // Production
  production_setProductionPlan,
  production_setYouDefrostedValue,
  production_setYouMadeValue,
  production_setAddToTotalStatus,
  production_setProductionPlanOnSave,
  production_setIsFrozenOpen,
  production_setIsOpen,
  // Forecast
  forecast_setSelectedPlanDateIndex,
  // Ingredient
  ingredient_setIngredients,
}

export type Actions =
  // Common
  | ISetUnsavedChanges
  | ISetBannerMessages
  | IAddBannerMessage
  | ISetPlanner
  | ISetUser
  // Ingredient
  | ISetIngredients

export const Reducer = (state: IContext, action: Actions): IContext => {
  switch (action.type) {
    // Common
    case ActionType.setUnsavedChanges:
      state.unsavedChanges = action.payload
      return state
    case ActionType.setBannerMessages:
      state.bannerMessages = action.payload
      return state
    case ActionType.addBannerMessage:
      state.bannerMessages.push({ banner: action.payload, time: new Date() })
      return state
    case ActionType.setPlanner:
      state.planner = action.payload
      return state
    case ActionType.setUser:
      state.user = action.payload
      return state
    case ActionType.ingredient_setIngredients:
      state.ingredients = action.payload
      return state

    default:
      return state
  }
}
